export const listOfFeatures = {
  AccountDeletion: true,
  AccountSettings: true,
  AllowParentViewClaims: true,
  Allowspouseviewclaims: true,
  AppreviewPrompt: true,
  Authorizations: true,
  BehavioralClaims: true,
  BehavioralHealthProvider: false,
  BehavioralHealthSearch: true,
  Benefits: true,
  BenefitsCoverage: true,
  CareATC: true,
  ChangePCP: true,
  CheckboxPopup: false,
  ChildOnlyPlan: false,
  ChildOnlyPlansFlow: false,
  ChooseHealthy: true,
  ClaimsStaticLink: false,
  ContactUs: true,
  dentalCoverage: false,
  ContactusSalesForce: true,
  CoveredEligibleMembers: true,
  DentalDominion: false,
  DesignatedRepresentativeTab: false,
  DrProfileSwitch: false,
  DoctorAndMedications: true,
  DoctorSearch: true,
  DocumentDeliveryPreferences: true,
  Dynatrace: false,
  EmailConsentPopup: false,
  EmergencyTravelAssistance: true,
  EmployeeAssistanceProgram: false,
  EnrollInBenefits: true,
  Eob: true,
  EstimateTreatmentCosts: false,
  FindADoctor: true,
  FindCare: true,
  FindDoctorsOrProviders: true,
  fitness: false,
  ForgeRockSecurityQuestionandAnswer: true,
  FormerAvmedMembers: false,
  FormsandDocuments: true,
  Formulary: true,
  FrequentlyAskedQuestions: true,
  GetHealthy: false,
  HSQEstimateTreatmentCosts: false,
  HealthSparqOneCostCalculator: false,
  HomeTiles: true,
  HospitalFacilityAndOtherServices: true,
  IBMEstimateTreatmentCosts: false,
  JivaCarePlan: false,
  LiveChat: false,
  LoginScreenDisable: true,
  MDLiveVirtualVisit: false,
  ManageHSA: false,
  ManageHealthReimbursementAccount: false,
  ManageorRenewPolicy: false,
  MedicalClaims: false,
  MemberRegistration: true,
  MemberServicesNumbers: true,
  MemberidCard: true,
  MyProfile: false,
  MpcInRegistration: true,
  NiceIncontact: false,
  OmniChannelLiveChat: true,
  OrderMemberIDCard: false,
  PayMonthlyPremium: false,
  PaymentsBillingAndClaims: true,
  PersonalHealthAssessment: false,
  PersonalHealthRecord: false,
  PharmacyBenefitsManager: true,
  PharmacyClaims: true,
  PharmacyResources: false,
  PharmacySearch: true,
  PlanDocuments: false,
  PlanList: true,
  PrescriptionDrugs: true,
  ProdSSLCert: true,
  ProfilePCP: true,
  RxSavings: false,
  ScheduleLabWork: false,
  SmartShopper: false,
  SMGProvider: true,
  SSLCert_v: true,
  TestiOS: true,
  UpdateEmailPrompt: false,
  UrgentCareSearch: true,
  ViewAnnualDeductiblesandMaximums: true,
  ViewCarePlan: true,
  ViewClaims: true,
  ViewIDCard: true,
  ViewTaxYearSummary: true,
  VisionCare: false,
  VisionTest: true,
  VirtualFirstHealthPlan: false,
  WellnessTools: false,
  YourPlan: true,
  faxIDCard: true,
  newIDCardFlow: true,
  printIDCard: true,
  shareIDCard: true,
  TextNotifications: false,
  TextNotificationPopup: false,
  // For not logged in users
  optimaHealth: true,
  members: true,
  providers: true,
  employers: true,
  brokers: true,
  VirtualVisitEAP: false,
  MaintenanceBanner: false,
  MemberIdRegistrationField: false,
  MaintenancePage: false,
  SmsShortCode: false,
  MedicarePlan: true,
  AdobeAnalytics: false,
  ProfileImageEdit: true,
  RegistrationMPCSkip: false,
  SuperEOBMedicalClaims: false,
  AzureAppInsights: false,
  FAQs: false,
  // New AI Chatbot feature flags
  NewChatBot: false,
  NewChatBotLiveAgent: true,
  NewChatBotSurvey: true,
  CityOfSunrise: false,
  CSATSurvey: false,
  CSATSurveyTimeout15s: false,
  CSATSurveyTimeout30s: false,
  CSATSurveyTimeout60s: false,
  CMSSiteCore: false,
};
